/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type LocationPaymentMethodDto,
    LocationPaymentMethodDtoFromJSON,
    LocationPaymentMethodDtoToJSON,
} from '../models/LocationPaymentMethodDto';

export interface GetPaymentMethodsForLocationRequest {
    locationId: number;
}

/**
 * 
 */
export class ClientPaymentMethodControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getPaymentMethodsForLocation without sending the request
     */
    async getPaymentMethodsForLocationRequestOpts(requestParameters: GetPaymentMethodsForLocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getPaymentMethodsForLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payment-methods`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodsForLocationRaw(requestParameters: GetPaymentMethodsForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LocationPaymentMethodDto>>> {
        const requestOptions = await this.getPaymentMethodsForLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LocationPaymentMethodDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodsForLocation(requestParameters: GetPaymentMethodsForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LocationPaymentMethodDto>> {
        const response = await this.getPaymentMethodsForLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
